export interface TfaPreauthRequest {
    scope: MFAScope;
    external: boolean;
    userId?: string;
    rememberMe?: boolean;
    deviceId?: string;
    useAppAuth?: boolean;
    orderType?: string;
    /** Order / QR amount for App Authenticator push approval display. */
    amount?: number | string;
    /** Peer / merchant / payee display name for App Authenticator push. */
    targetName?: string;
    /** Last 4 digits of the card/account number for CARD_PIN and MULTI_CARD_STATUS. */
    cardNumber?: string;
    vizAliasType?: string;
    vizAliasValue?: string;
    currentStatus?: string;
    newStatus?: string;
}

export interface TfaAuthRequest {
    scope: MFAScope;
    token: string;
    userResponse?: string;
    userId?: string;
    orderType?: string;
    deviceId?: string;
    trustDevice?: boolean;
}

export interface TokenResponseBean {
    token: string;
    userId: string;
    registrationUrl?: string;
    challengeType?: string;
    actionResult?: string;
}

export const enum MFAScope {
    SELF_REGISTRATION = "SELF_REGISTRATION",
    TRANSACTION = "TRANSACTION",
    ORDER = "ORDER",
    LOGIN = "LOGIN",
    ADD_PEER = "ADD_PEER",
    CARD_PIN = "CARD_PIN",
    RESET_PASSWORD = "RESET_PASSWORD",
    QR_CODE = "QR_CODE",
    BATCH_ORDER = "BATCH_ORDER",
    MULTI_CARD_STATUS = "CC_CARD_STATUS",
    EXTERNAL_PAYMENT = "EXTERNAL_PAYMENT",
    DOMESTIC_PAYMENT = "DOMESTIC_PAYMENT",
    VIZ_SEND_MONEY = "VIZ_SEND_MONEY",
    BIOMETRIC_CHANGE = "BIOMETRIC_CHANGE",
    APP_AUTHENTICATE_ACTIVATE = "APP_AUTHENTICATE_ACTIVATE",
    TOPUP_TRANSACTION = "TOPUP_TRANSACTION",
	TOPUP_PAYEE = "TOPUP_PAYEE",
	BILL_PAYMENT = "BILL_PAYMENT",
	PEER_PAYMENT = "PEER_PAYMENT",
    PAYROLL = "PAYROLL",
}

export enum MFAResult {
    VERIFIED = "VERIFIED",
    RETRY = "RETRY",
    UNVERIFIED = "UNVERIFIED",
    TOO_MANY = "TOO_MANY",
    EXPIRED = "EXPIRED",
    /** Fraud review (4780) after this MFA challenge. OTP dialog is already closed. */
    ACCOUNT_MONITORING_REVIEW = "ACCOUNT_MONITORING_REVIEW"
}
